import React from 'react'
import { Link } from 'react-router-dom'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import styles from './displayProviderRates.module.scss'
import { PROVIDERS_DETAILS_EDIT_RATES } from '../../../../common/constants/routingConstants'

type Props = {
  $$data?: any
}

// TODO! UPDATE SO THE DISPLAYED RATES ARE BASED ON DATA AND NOT HARD CODED.
const DisplayProviderRates: React.FC<Props> = ({ $$data }) => {
  const { isTimeBasedDABillingEnabled } = useFlags()
  return (
    <div className={styles['content-container']}>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Initial Evaluation (individual) Rate</div>
          <p>{$$data.get('individual_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Follow Up Session (individual) Rate</div>
          <p>{$$data.get('individual_follow_up_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Initial Evaluation (couples) Rate</div>
          <p>{$$data.get('couples_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Follow Up Session (couples) Rate</div>
          <p>{$$data.get('couples_follow_up_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Initial Evaluation (family) Rate</div>
          <p>{$$data.get('family_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Follow Up Session (family) Rate</div>
          <p>{$$data.get('family_follow_up_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Initial Evaluation (group) Rate</div>
          <p>{$$data.get('group_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Follow Up Session (group) Rate</div>
          <p>{$$data.get('group_follow_up_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>
            {isTimeBasedDABillingEnabled
              ? 'Med Management Initial Evaluation'
              : 'Initial Evaluation (medication management) Rate'}
          </div>
          <p>{$$data.get('medication_management_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>
            {isTimeBasedDABillingEnabled
              ? 'Med Management Follow-Up (Legacy)'
              : 'Follow Up Session (medication management) Rate'}
          </div>
          <p>{$$data.get('medication_management_follow_up_session')}</p>
        </div>
      </div>
      {isTimeBasedDABillingEnabled && (
        <div className='row'>
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>Med Management Low Complexity Follow-Up (20-29min)</div>
            <p>{$$data.get('medication_management_follow_up_low_complexity')}</p>
          </div>
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>Med Management Moderate Complexity Follow-Up (30-39min)</div>
            <p>{$$data.get('medication_management_follow_up_moderate_complexity')}</p>
          </div>
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>Med Management High Complexity Follow-Up (40+min)</div>
            <p>{$$data.get('medication_management_follow_up_high_complexity')}</p>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>SMP Rate</div>
          <p>{$$data.get('smp_session')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>GSC Rate</div>
          <p>{$$data.get('ssc_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Initial Evaluation (minor) Rate</div>
          <p>{$$data.get('child_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Follow Up Session (minor) Rate</div>
          <p>{$$data.get('child_follow_up_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>
            {isTimeBasedDABillingEnabled ? 'Minor Med Management Initial Evaluation' : 'Minor Intake (prescriber) Rate'}
          </div>
          <p>{$$data.get('minor_medication_management_initial_evaluation')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>
            {isTimeBasedDABillingEnabled
              ? 'Minor Med Management Follow-Up (Legacy)'
              : 'Minor Follow Up (prescriber) Rate'}
          </div>
          <p>{$$data.get('minor_medication_management_follow_up_evaluation')}</p>
        </div>
      </div>
      {isTimeBasedDABillingEnabled && (
        <div className='row'>
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>Minor Med Management Low Complexity Follow-Up (20-29min)</div>
            <p>{$$data.get('minor_medication_management_follow_up_low_complexity')}</p>
          </div>
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>Minor Med Management Moderate Complexity Follow-Up (30-39min)</div>
            <p>{$$data.get('minor_medication_management_follow_up_moderate_complexity')}</p>
          </div>
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>Minor Med Management High Complexity Follow-Up (40+min)</div>
            <p>{$$data.get('minor_medication_management_follow_up_high_complexity')}</p>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>AUD rate - Therapy</div>
          <p>{$$data.get('alcohol_use_disorder_session')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Session Rate</div>
          <p>{$$data.get('dbt_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Group Session Rate</div>
          <p>{$$data.get('dbt_group_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Intake Session Rate</div>
          <p>{$$data.get('dbt_teens_intake_session')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Follow-Up Session Rate</div>
          <p>{$$data.get('dbt_teens_followup_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Caregiver Session Rate</div>
          <p>{$$data.get('dbt_teens_caregiver_session')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Family Session Rate</div>
          <p>{$$data.get('dbt_teens_family_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Group Session Rate</div>
          <p>{$$data.get('dbt_teens_group_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Medication Initial Session Rate</div>
          <p>{$$data.get('dbt_teens_medication_initial_session')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>DBT Teens Medication Follow-Up Session Rate</div>
          <p>{$$data.get('dbt_teens_medication_followup_session')}</p>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Caregiver Training Session Rate</div>
          <p>{$$data.get('caregiver_training_for_neuro_session')}</p>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Neurodiversity Skills Coaching Session Rate</div>
          <p>{$$data.get('neurodiversity_skills_coaching_session')}</p>
        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          <div className={styles['field-label']}>Differential Pricing Status</div>
          <p>{$$data.get('differential_pricing_enabled') ? 'Enabled' : 'Disabled'}</p>
        </div>
        {$$data.get('differential_pricing_enabled') && (
          <div className='col-xs-12 col-sm-6'>
            <div className={styles['field-label']}>In Person Modifier</div>
            <p>{$$data.get('differential_pricing_in_person_modifier')}</p>
          </div>
        )}
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <Link className={styles['edit-link']} to={PROVIDERS_DETAILS_EDIT_RATES.route} replace>
            Edit Rates
          </Link>
        </div>
      </div>
    </div>
  )
}

export default DisplayProviderRates
